import { render } from "./AppContent.vue?vue&type=template&id=0c577a78&scoped=true"
import script from "./AppContent.vue?vue&type=script&lang=js"
export * from "./AppContent.vue?vue&type=script&lang=js"

import "./AppContent.vue?vue&type=style&index=0&id=0c577a78&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c577a78"]])

export default __exports__